// extracted by mini-css-extract-plugin
module.exports = {"aiTag":"AiTag_aiTag___1XsF"};